import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Order } from "@/api/models/api-types";
import { OrderItemCard } from "./OrderItemCard";

interface OrderMerchantSectionProps {
  order: Order;
}

export const OrderMerchantSection: React.FC<OrderMerchantSectionProps> = ({
  order,
}) => {
  // Get merchant base URL (prioritize direct merchantUrl, then metadata, then seoName)
  const merchantUrl =
    order.merchantUrl ||
    order.metadata?.merchantUrl ||
    (order.merchantSeoName ? `https://${order.merchantSeoName}.com` : "#");

  return (
    <div className="space-y-4 md:space-y-6">
      {/* Merchant Badge */}
      <a
        href={merchantUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-1.5 px-1.5 py-0.5 bg-[#fafafa] dark:bg-gray-800 border border-[#e9eaeb] dark:border-gray-700 rounded-md w-fit hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors cursor-pointer"
      >
        {/* Merchant Logo */}
        {order.merchantLogoUrl && (
          <img
            src={order.merchantLogoUrl}
            alt={order.merchantName}
            className="w-3.5 h-3.5 md:w-4 md:h-4 object-contain flex-shrink-0"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        )}

        <span className="text-[11px] md:text-[12px] font-medium text-[#364152] dark:text-gray-300">
          {order.merchantName}
        </span>
        <ArrowUpRight className="w-2.5 h-2.5 md:w-3 md:h-3 text-[#364152] dark:text-gray-300" />
      </a>

      {/* Order Items */}
      <div className="space-y-4 md:space-y-6">
        {order.items.map((item, index) => (
          <OrderItemCard key={index} item={item} currency={order.currency} />
        ))}
      </div>
    </div>
  );
};
